var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statements w3-border"},_vm._l((_vm.convo.meta.statements),function(statement){return _c('div',{staticClass:"w3-card"},[_c('p',[_c('statement-view',{attrs:{"statement":statement,"buttonType":_vm.buttonType}})],1)])}))}
var staticRenderFns = []

export { render, staticRenderFns }